document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

        if (element.closest('.top-content')) {
            setupTraveler(swiper);
        }

    });

    function setupTraveler(swiper) {

        const pagination = swiper.pagination.el;
        if (!pagination) return;

        const traveler = document.createElement('div');
        traveler.className = 'bullet-traveler';

        pagination.appendChild(traveler);

        let previousIndex = swiper.realIndex;

        swiper.on('slideChangeTransitionStart', () => {

            const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
            if (!bullets.length) return;

            if (
                previousIndex === bullets.length - 1 &&
                swiper.realIndex === 0
            ) {
                requestAnimationFrame(() => {
                    animateTraveler();
                });
            }

            previousIndex = swiper.realIndex;

        });

        function animateTraveler() {

            const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');

            const first = bullets[0];
            const last = bullets[bullets.length - 1];

            const paginationRect = pagination.getBoundingClientRect();
            const firstRect = first.getBoundingClientRect();
            const lastRect = last.getBoundingClientRect();

            const offset = (13 - 12) / 2;

            const startX = lastRect.left - paginationRect.left - offset;
            const endX = firstRect.left - paginationRect.left - offset;
            const startY = lastRect.top - paginationRect.top - offset;

            pagination.classList.add('is-looping');

            traveler.style.display = 'block';
            traveler.style.transition = 'none';
            traveler.style.left = `${startX}px`;
            traveler.style.top = `${startY}px`;

            requestAnimationFrame(() => {
                traveler.style.transition = 'left .2s linear';
                traveler.style.left = `${endX}px`;
            });

            clearTimeout(traveler.loopTimeout);

            traveler.loopTimeout = setTimeout(() => {

                traveler.style.display = 'none';
                traveler.style.transition = 'none';

                pagination.classList.remove('is-looping');

            }, 200);
        }
    }
});